import React, { useContext, useState, useEffect, useCallback } from "react";
import {
  Button,
  Modal,
  TextInput,
  Select,
} from "flowbite-react";
import { Store } from "../context/store";
import { IoMdAddCircleOutline, IoIosSearch } from "react-icons/io";
import { useSearchParams, Link } from "react-router-dom";
import apiRequest from "../utils/apiRequest";
import { HiTrash } from "react-icons/hi";
import { useAllPermissions } from "../utils/usePermission";
import { confirmDialog } from "../components/ConfirmDialog";
import DashboardLayout from "../components/layout/DashboardLayout";
import DataTable from "../components/data/DataTable";
import SessionExpiredModal from "../components/SessionExpiredModal";
import { useSessionExpiry } from "../hooks/useSessionExpiry";
// import { HiEye, HiEyeOff } from "react-icons/hi"; // Import icons

function Customers() {
  let store = useContext(Store);
  let [baseUrl] = store.url;
  let [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page")) || 1;
  let [clients, setClients] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(page);
  const [search, setSearch] = useState("");
  let [error, setError] = useState("");
  let [errorColor, setErrorColor] = useState("");
  let [deletingClientId, setDeletingClientId] = useState(null);
  // let [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [clientDetails, setClientDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "Qwerty@123",
    confirmPassword: "Qwerty@123",
    gender: "",
    dob: "",
    maritalStatus: "",
    nextOfKin: "",
    nextOfKinPhone: "",
    nationality: "",
    occupation: "",
    address: "",
    phone: "",
    typeOfIdentification: "",
    status: "active",
  });

  let [loading3, setLoading3] = useState(false);
  const { isSessionExpired, handleAuthError, confirmSessionExpired } =
    useSessionExpiry();

  function onCloseModal() {
    setOpenModal(false);
  }

  const loadClients = useCallback(
    async (a) => {
      setLoading(true);
      try {
        let token = localStorage.getItem("royal-token");
        let url;
        if (a) {
          url = `${baseUrl}/clients?search=${a}`;
        } else {
          url = `${baseUrl}/clients?page=${page}`;
        }
        const { data } = await apiRequest(url, "GET", null, token);
        setClients(data.clients);
        setTotalPages(data.totalPages);
      } catch (error) {
        handleAuthError(error);
      } finally {
        setLoading(false);
      }
    },
    [page, baseUrl, handleAuthError]
  );

  useEffect(() => {
    Promise.all([loadClients()])
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  }, [loadClients]);

  const onPageChange = (page) => {
    setSearchParams({ page: page });
    setCurrentPage(page);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setClientDetails((prev) => ({ ...prev, [name]: value }));
  };

  const searchClient = async (a) => {
    if (!a) return;
    await loadClients(a);
    setSearch("");
    setLoading(false);
  };

  const resetSearchClient = async () => {
    await loadClients();
    setSearch("");
    setLoading(false);
  };

  const deleteClient = async (client) => {
    if (client?.approved !== false) return;

    await confirmDialog(
      `Are you sure you want to delete ${client.firstName || "this"} ${
        client.lastName || "client"
      }?`,
      {
        title: "Delete Client",
        confirmText: "Yes, delete",
        color: "failure",
        loadingText: "Deleting...",
        onConfirm: async () => {
          setDeletingClientId(client.id);
          try {
            let token = localStorage.getItem("royal-token");
            const url = `${baseUrl}/client/${client.id}`;
            await apiRequest(url, "DELETE", null, token);
            await loadClients(search);
          } catch (error) {
            handleAuthError(error);
            alert(error.message || "Failed to delete client.");
          } finally {
            setDeletingClientId(null);
          }
        },
      },
    );
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setError("");
    setClientDetails({
      firstName: "",
      lastName: "",
      email: "",
      password: "Qwerty@123",
      confirmPassword: "Qwerty@123",
      gender: "",
      dob: "",
      maritalStatus: "",
      nextOfKin: "",
      nextOfKinPhone: "",
      nationality: "",
      occupation: "",
      address: "",
      phone: "",
      typeOfIdentification: "",
      status: "active",
    });
  };

  const registerClient = async (a, b) => {
    if (
      !clientDetails.confirmPassword ||
      !clientDetails.password ||
      !clientDetails.phone ||
      !clientDetails.address ||
      !clientDetails.firstName ||
      !clientDetails.lastName
    ) {
      setErrorColor("red");
      setError("Please fill all missing fields.");
      return;
    }
    if (!validatePassword(clientDetails.password)) {
      setErrorColor("red");
      setError(
        "Password: Minimun of 8 characters, including uppercase, lowercase, numbers, and special characters."
      );
      return;
    }
    if (clientDetails.confirmPassword !== clientDetails.password) {
      setErrorColor("red");
      setError("Password and Confirm Password do not match.");
      return;
    }
    await confirmDialog(
      "Are you sure you want to add a new client?",
      {
        title: "Add Client",
        confirmText: "Yes, add client",
        color: "success",
        loadingText: "Adding...",
        onConfirm: async () => {
          setLoading3(true);
          try {
            let token = localStorage.getItem("royal-token");
            const url = `${baseUrl}/client`;
            await apiRequest(url, "POST", clientDetails, token);
            setErrorColor("green");
            setError("Successfully registered.");
            setLoading3(false);
            setClientDetails({
              firstName: "",
              lastName: "",
              email: "",
              password: "Qwerty@123",
              confirmPassword: "Qwerty@123",
              gender: "",
              dob: "",
              maritalStatus: "",
              nextOfKin: "",
              nextOfKinPhone: "",
              nationality: "",
              occupation: "",
              address: "",
              phone: "",
              typeOfIdentification: "",
              status: "active",
            });
            setError("");
            onCloseModal();
            loadClients();
            setLoading(false);
          } catch (error) {
            if (!handleAuthError(error)) {
              setErrorColor("red");
              setError(error.message);
              setLoading3(false);
            }
          }
        },
      },
    );
  };

  const { canWriteClients } = useAllPermissions();

  const clientColumns = [
    {
      key: "name",
      header: "Name",
      className: "whitespace-nowrap font-medium text-gray-900 dark:text-white",
      render: (client) => `${client?.firstName || ""} ${client?.lastName || ""}`,
    },
    {
      key: "phone",
      header: "Phone",
      className: "text-ellipsis",
    },
    {
      key: "address",
      header: "Address",
      className: "text-ellipsis",
      render: (client) => client?.address,
    },
    {
      key: "gender",
      header: "Gender",
      className: "text-ellipsis",
    },
    {
      key: "approval",
      header: "Approval",
      render: (client) => (
        <span
          className={`rounded px-2 py-1 text-xs font-semibold ${
            client.approved
              ? "bg-green-100 text-green-700"
              : "bg-yellow-100 text-yellow-700"
          }`}
        >
          {client.approved ? "Approved" : "Pending"}
        </span>
      ),
    },
    {
      key: "actions",
      header: <span className="sr-only">Actions</span>,
      render: (client) => (
        <div className="flex items-center gap-3">
          <Link
            to={`/client/${client.id}`}
            className="font-medium text-cyan-600 hover:underline dark:text-cyan-500"
            style={{ textDecoration: "none" }}
          >
            View
          </Link>
          {client.approved === false && (
            <Button
              size="xs"
              color="failure"
              title="Delete unapproved client"
              onClick={() => deleteClient(client)}
              disabled={!canWriteClients || deletingClientId === client.id}
            >
              <HiTrash className="h-4 w-4" />
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <title>Clients</title>
      <meta
        name="description"
        content="Customers Page to the Royalmines Property Office"
      />

      <DashboardLayout active="clients" animation="zoom-in">
            <div className="mb-4">
              <h5 className="text-xl font-bold leading-none text-gray-900 dark:text-white">
                Clients
              </h5>
              <div className="flex flex-wrap gap-2 mt-5 justify-between">
                <div className="max-w-md flex">
                  <TextInput
                    id="search4"
                    type="text"
                    placeholder="Search by name, phone or email"
                    className="w-fit me-3"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <Button
                    className="me-2"
                    color="dark"
                    onClick={() => searchClient(search)}
                  >
                    <IoIosSearch className="me-2" />
                    Search
                  </Button>
                  <Button onClick={() => resetSearchClient()}>
                    <IoIosSearch className="me-2" />
                    Reset
                  </Button>
                </div>
                <Button
                  color="success"
                  onClick={() => setOpenModal(true)}
                  disabled={!canWriteClients}
                >
                  <IoMdAddCircleOutline className="me-2" />
                  New Client
                </Button>
              </div>
            </div>
            <DataTable
              columns={clientColumns}
              rows={clients}
              loading={loading}
              emptyTitle={search ? "No clients match this search" : "No clients yet"}
              emptyDescription={
                search
                  ? "Try another name, phone number, or email address."
                  : "Registered clients will appear here once they are added."
              }
              bodyClassName="divide-y uppercase"
              pagination={{
                currentPage,
                totalPages,
                onPageChange,
              }}
            />
      </DashboardLayout>

      {/* modal for add client */}
      <Modal
        show={openModal}
        onClose={() => handleCloseModal()}
        theme={{
          root: {
            base: "fixed inset-0 z-[2000] h-full w-full overflow-y-auto overflow-x-hidden md:inset-0 md:h-full",
          },
          content: {
            inner:
              "relative rounded-lg bg-white shadow dark:bg-gray-700 flex flex-col max-h-full",
          },
          // The backdrop needs a high z-index too
          backdrop: "fixed inset-0 z-[1990] bg-gray-900/50 dark:bg-gray-900/80",
        }}
      >
        <Modal.Header>New Client Registration</Modal.Header>
        <div className="flex justify-center">
          <small
            style={{
              color: errorColor,
              textAlign: "center",
            }}
          >
            {error}
          </small>
        </div>
        <Modal.Body>
          <form>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <TextInput
                name="firstName"
                placeholder="First Name"
                value={clientDetails.firstName}
                onChange={handleInputChange}
                required
              />
              <TextInput
                name="lastName"
                placeholder="Last Name"
                value={clientDetails.lastName}
                onChange={handleInputChange}
                required
              />
              <TextInput
                name="email"
                type="email"
                placeholder="Email"
                value={clientDetails.email}
                onChange={handleInputChange}
              />
              {/* <div className="relative">
                <TextInput
                  id="password1"
                  type={showPassword ? "text" : "password"} // Toggle input type
                  required
                  placeholder="Enter Password"
                  name="password"
                  value={clientDetails.password}
                  onChange={handleInputChange}
                />
                <span
                  className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)} // Toggle visibility state
                >
                  {showPassword ? (
                    <HiEyeOff className="text-gray-500" />
                  ) : (
                    <HiEye className="text-gray-500" />
                  )}
                </span>
              </div>
              <TextInput
                name="confirmPassword"
                type="password"
                placeholder="Confirm Password"
                value={clientDetails.confirmPassword}
                onChange={handleInputChange}
                required
              /> */}
              <Select
                name="gender"
                placeholder="Gender"
                value={clientDetails.gender}
                onChange={handleInputChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </Select>
              <TextInput
                name="dob"
                type="date"
                placeholder="Date of Birth"
                value={clientDetails.dob}
                onChange={handleInputChange}
              />
              <TextInput
                name="maritalStatus"
                placeholder="Marital Status"
                value={clientDetails.maritalStatus}
                onChange={handleInputChange}
              />
              <TextInput
                name="nextOfKin"
                placeholder="Next of Kin"
                value={clientDetails.nextOfKin}
                onChange={handleInputChange}
              />
              <TextInput
                name="nextOfKinPhone"
                placeholder="Next of Kin Phone"
                value={clientDetails.nextOfKinPhone}
                onChange={handleInputChange}
              />
              <TextInput
                name="nationality"
                placeholder="Nationality"
                value={clientDetails.nationality}
                onChange={handleInputChange}
              />
              <TextInput
                name="occupation"
                placeholder="Occupation"
                value={clientDetails.occupation}
                onChange={handleInputChange}
              />
              <TextInput
                name="address"
                placeholder="Address"
                value={clientDetails.address}
                onChange={handleInputChange}
              />
              <TextInput
                name="phone"
                placeholder="Client Phone Number"
                value={clientDetails.phone}
                onChange={handleInputChange}
                required
              />
              <Select
                name="typeOfIdentification"
                placeholder="Type of Identification"
                value={clientDetails.typeOfIdentification}
                onChange={handleInputChange}
              >
                <option value="">Select Identification Type</option>
                <option value="passport">Passport</option>
                <option value="driverLicense">Driver's License</option>
                <option value="nationalId">National ID</option>
              </Select>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={loading3} onClick={() => registerClient()}>
            {loading3 ? "Loading..." : "Register"}
          </Button>
          <Button color="gray" onClick={() => handleCloseModal()}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <SessionExpiredModal
        open={isSessionExpired}
        onOk={confirmSessionExpired}
      />
    </>
  );
}

export default Customers;

function validatePassword(password) {
  const re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_]).{8,}$/;
  return re.test(password);
}
